// Definimos a versão da api que está sendo utilizada em todas as requisições
import {version} from "./config";

export default {
  checkIfAuthenticated() {
    return axiosWithoutLoading.get(`/api/${version}/usuario/logado`);
  },
  getAuthUser(cb) {
    return axios.get(`/api/${version}/usuario`).then(({ data }) => cb(data));
  },
  cadastrarUsuario(payload) {
    return axios.post(`/cadastrar`, payload);
  },
  enviarMensagem(payload) {
    return axios.post(`/enviar-mensagem`, payload);
  },
  doLogin(payload) {
    return axios.post(`/login`, payload);
  },
  tornarBeta(payload) {
    return axios.post(`/api/${version}/usuario/beta`, payload);
  },
  lerNotificacao(id, payload) {
    return axiosWithoutLoading.get(`/api/${version}/notificacoes/${id}`);
  },
  lerTodasNotificacoes() {
    return axiosWithoutLoading.post(`/api/${version}/notificacoes/ler-todas`);
  },
  visualizarTodasNotificacoes() {
    return axiosWithoutLoading.post(
      `/api/${version}/notificacoes/visualizar-todas`
    );
  },
  getPesquisa(id, loading = true) {
    if (loading) {
      return axios.get(`/api/${version}/pesquisas/${id}`);
    } else {
      return axiosWithoutLoading.get(`/api/${version}/pesquisas/${id}`);
    }
  },
  responderNps(payload, loading) {
    const http = loading ? axios : axiosWithoutLoading;
    return http.post(`/api/v2/pesquisas/nps`, payload);
  },
  salvarPesquisa(id, payload, loading = true) {
    if (loading) {
      return axios.post(`/api/${version}/pesquisas/${id}/responder`, payload);
    } else {
      return axiosWithoutLoading.post(
        `/api/${version}/pesquisas/${id}/responder`,
        payload
      );
    }
  },
  reenviarEmailConfirmacao(payload, loading = true) {
    if (loading) {
      return axios.post(`/api/${version}/reenviar-confirmacao-email`, payload);
    } else {
      axiosWithoutLoading.post(
        `/api/${version}/reenviar-confirmacao-email`,
        payload
      );
      return Promise.resolve();
    }
  },
  update(id, payload, loading = true) {
    if (loading) {
      return axios.put(`/api/${version}/usuario/${id}`, payload);
    } else {
      return axiosWithoutLoading.put(`/api/${version}/usuario/${id}`, payload);
    }
  },
  cidadePorIp() {
    return axios.get(`/ajax/cidade-por-ip`);
  },
  enderecoPorCep(cep) {
    return axiosWithoutLoading.get(`/ajax/endereco-por-cep?cep=${cep}`);
  },
  registrarAcao(payload) {
    return axios.post(`/api/${version}/usuario/registrar-acao`, payload);
  },
  changelogs(page, limit = null) {
    let params = limit ? `limit=${limit}&page=${page}` : `page=${page}`;
    return axios.get(`/dados-changelogs?${params}`)
  }
};
